import { useEffect } from "react";
import { trackView } from "@/lib/analytics";

/**
 * Auto-tracks section views using IntersectionObserver.
 * Fires "section_view" event once per section per page load when >=50% visible.
 */
export default function useSectionViewTracker() {
  useEffect(() => {
    const sections = document.querySelectorAll("[data-testid$='-section']");
    if (!sections.length) return;

    const fired = new Set();
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const name = entry.target.getAttribute("data-testid")?.replace("-section", "");
          if (!name || fired.has(name)) return;
          fired.add(name);
          trackView(name);
        });
      },
      { threshold: 0.5 },
    );
    sections.forEach((s) => io.observe(s));
    return () => io.disconnect();
  }, []);
}
